import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "../baseQuery";
import {
  OTP_LOGIN,
  RESEND_OTP,
  SIGN_UP,
  VERIFY_OTP_LOGIN,
  VERIFY_OTP_SIGNUP,
} from "../routes";

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery,
  endpoints: (builder) => ({
    login: builder.mutation<
      ApiResponse<PatientDetailsTypes>,
      { mobile: string }
    >({
      query: (credentials) => ({
        url: OTP_LOGIN,
        method: "POST",
        body: credentials,
      }),
    }),

    verifyOtpLogin: builder.mutation<
      ApiResponse<PatientDetailsTypes>,
      Record<string, any>
    >({
      query: (credential) => ({
        url: VERIFY_OTP_LOGIN,
        method: "POST",
        body: credential,
      }),
    }),
    signup: builder.mutation<
      ApiResponse<signUpDataTypes>,
      { mobile: string; email: string; first_name: string; last_name: string }
    >({
      query: (credentials) => ({
        url: SIGN_UP,
        method: "POST",
        body: credentials,
      }),
    }),
    verifySignupOtp: builder.mutation<
      ApiResponse<PatientDetailsTypes>,
      {
        mobile: string;
        unique_temp_id: number | undefined;
        otp: string;
      }
    >({
      query: (credentials) => ({
        url: VERIFY_OTP_SIGNUP,
        method: "POST",
        body: credentials,
      }),
    }),
    recendOtp: builder.mutation<
      ApiResponse<PatientDetailsTypes>,
      Record<string, any>
    >({
      query: (credentials) => ({
        url: RESEND_OTP,
        method: "POST",
        body: credentials,
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useSignupMutation,
  useVerifyOtpLoginMutation,
  useVerifySignupOtpMutation,
  useRecendOtpMutation,
} = authApi;
